module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_3016.3dee4f08.png";